import { render, staticRenderFns } from "./UserEditSecurityDetails.vue?vue&type=template&id=2ac036ca&"
import script from "./UserEditSecurityDetails.vue?vue&type=script&lang=js&"
export * from "./UserEditSecurityDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports